import React from 'react';

import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';
import {useCurrentUserPendingTasksQuery} from 'client/SignUp/NewSignUp/signUp.queries.generated';

import ForceOnboarding from './ForceOnboarding.react';

interface ForceOnboardingGateProps {
  children: React.ReactNode;
}

/**
 * Wraps ForceOnboarding with the new_signup_flow feature flag check.
 */
export default function ForceOnboardingGate({children}: ForceOnboardingGateProps) {
  const {isFeatureEnabled, isLoading: flagLoading} = useIsFeatureFlagEnabled('new_signup_flow');

  const {data: pendingData, loading: pendingLoading} = useCurrentUserPendingTasksQuery({
    skip: !isFeatureEnabled || flagLoading,
    fetchPolicy: 'network-only'
  });

  // Block rendering until the feature flag resolves.
  if (flagLoading) {
    return null;
  }

  const pendingTasks = pendingData?.currentUser?.signupPending ?? [];
  const signupComplete = pendingData?.currentUser?.signupComplete ?? false;
  const isTeacher = pendingData?.currentUser?.isTeacher ?? false;

  return (
    <ForceOnboarding
      useNewOnboardingFlow={isFeatureEnabled}
      pendingSignupTasks={pendingTasks}
      signupComplete={signupComplete}
      pendingTasksLoading={pendingLoading && isFeatureEnabled}
      isTeacher={isTeacher}
    >
      {children}
    </ForceOnboarding>
  );
}
